"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Container = exports.Container = _styledComponents["default"].div.withConfig({
  displayName: "Container",
  componentId: "sc-1yf4tyt-0"
})(["", ";position:relative;inline-size:100%;display:flex;align-items:center;"], (0, _index.rootStyle)());